import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete, MdVisibility, MdFilterList } from "react-icons/md";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import InputSearch from "../../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { GrAdd } from "react-icons/gr";
import { LuArrowDownUp } from "react-icons/lu";
import { getApiInstance } from "../../../utils/api";
import { useZone } from "../../../context/ZoneContext";

const usuariosData = [
  {
    id: 1,
    nombre: "Usuario",
    apellidos: "Uno",
    perfil: "Administrador",
    acceso: "Gestión",
    empresa: "Intermediario 1",
    telefono: "600 111 001",
    email: "usuario1@email.com",
  },
  {
    id: 2,
    nombre: "Usuario",
    apellidos: "Dos",
    perfil: "Editor",
    acceso: "Consulta",
    empresa: "Intermediario 2",
    telefono: "600 222 002",
    email: "usuario2@email.com",
  },
  {
    id: 3,
    nombre: "Usuario",
    apellidos: "Tres",
    perfil: "Visor",
    acceso: "Consulta",
    empresa: "Intermediario 1",
    telefono: "600 333 003",
    email: "usuario3@email.com",
  },
  {
    id: 4,
    nombre: "Usuario",
    apellidos: "Cuatro",
    perfil: "Administrador",
    acceso: "Gestión",
    empresa: "Intermediario 3",
    telefono: "600 444 004",
    email: "usuario4@email.com",
  },
  {
    id: 5,
    nombre: "Usuario",
    apellidos: "Cinco",
    perfil: "Editor",
    acceso: "Gestión",
    empresa: "Intermediario 2",
    telefono: "600 555 005",
    email: "usuario5@email.com",
  },
  {
    id: 6,
    nombre: "Usuario",
    apellidos: "Seis",
    perfil: "Visor",
    acceso: "Consulta",
    empresa: "Intermediario 4",
    telefono: "600 666 006",
    email: "usuario6@email.com",
  },
  {
    id: 7,
    nombre: "Usuario",
    apellidos: "Siete",
    perfil: "Administrador",
    acceso: "Gestión",
    empresa: "Intermediario 1",
    telefono: "600 777 007",
    email: "usuario7@email.com",
  },
  {
    id: 8,
    nombre: "Usuario",
    apellidos: "Ocho",
    perfil: "Editor",
    acceso: "Consulta",
    empresa: "Intermediario 5",
    telefono: "600 888 008",
    email: "usuario8@email.com",
  },
  {
    id: 9,
    nombre: "Usuario",
    apellidos: "Nueve",
    perfil: "Visor",
    acceso: "Consulta",
    empresa: "Intermediario 3",
    telefono: "600 999 009",
    email: "usuario9@email.com",
  },
  {
    id: 10,
    nombre: "Usuario",
    apellidos: "Diez",
    perfil: "Administrador",
    acceso: "Gestión",
    empresa: "Intermediario 2",
    telefono: "600 000 010",
    email: "usuario10@email.com",
  },
  {
    id: 11,
    nombre: "Usuario",
    apellidos: "Once",
    perfil: "Editor",
    acceso: "Gestión",
    empresa: "Intermediario 4",
    telefono: "600 111 011",
    email: "usuario11@email.com",
  },
  {
    id: 12,
    nombre: "Usuario",
    apellidos: "Doce",
    perfil: "Visor",
    acceso: "Consulta",
    empresa: "Intermediario 5",
    telefono: "600 222 012",
    email: "usuario12@email.com",
  },
];

const columnasUsuarios = [
  { key: "id", label: "codUsuario", visible: false },
  { key: "codUsuario", label: "codUsuario", visible: false },
  {
    key: "nombre",
    label: "Nombre",
    visible: true,
    isLink: true,
    sortable: true,
  },
  { key: "apellidos", label: "Apellidos", visible: true, sortable: true },
  { key: "perfil", label: "Perfil", visible: true, sortable: true },
  { key: "acceso", label: "Acceso", visible: true, sortable: true },
  {
    key: "intermediario",
    label: "Empresa Intermediaria",
    visible: true,
    sortable: true,
  },
  { key: "telefono", label: "Teléfono", visible: true, sortable: true },
  { key: "email", label: "Email", visible: true, sortable: true },
];

const filterFields = [
  { key: "perfil", label: "Perfil", type: "multiselect" },
  { key: "acceso", label: "Acceso", type: "multiselect" },
  { key: "intermediario", label: "Empresa Intermediaria", type: "multiselect" },
];

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState(usuariosData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();

  useEffect(() => {
    fetchUsuarios();
  }, [selectedZone]);

  const fetchUsuarios = async () => {
    setLoading(true);
    const api = getApiInstance();

    try {
      let usuariosData = [];

      const response = await api.get(`/api/Usuario/GetUsuariosByZona/${selectedZone.value}`);
      usuariosData = response.data;

      console.log("Paises data fetched:", usuariosData);

      setUsuarios(usuariosData);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los usuarios. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="muebles-pages__error-message">
        Cargando comunidades...
      </div>
    );
  if (error)
    return <div className="muebles-pages__error-message">Error: {error}</div>;

  return (
    <PageLayout
      title="Usuarios"
      subtitle="Gestión de usuarios registrados en el sistema"
    >
      <Table
        columns={columnasUsuarios}
        dataTable={usuarios}
        showCheckboxes={true}
        noResultsMessage="No se han encontrado usuarios."
        searchTerms={["nombre", "apellidos", "email","telefono", "empresaIntermediaria", "perfil", "acceso"]}
			actions={["Eliminar", "Editar"]}
			elementName="Usuario"
			formElements={[
				{
					elements: [
						{
							name: "email",
							type: "text",
							label: "Email",
							placeholder: "Introduce el email",
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						},
						{
							name: "nombre",
							type: "text",
							label: "Nombre",
							placeholder: "Introduce el nombre",
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						},
						{
							name: "apellidos",
							type: "text",
							label: "Apellidos",
							placeholder: "Introduce los apellidos",
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						},
						{
							name: "telefono",
							type: "tel",
							label: "Teléfono",
							placeholder: "Introduce el teléfono",
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						},
						{
							name: "codPerfil",
							type: "select",
							label: "Perfil",
							placeholder: "Selecciona el perfil",
							options: [
								{ label: "Administrador global", value: "1", id:1, associatedField: "codPerfil"},
								{ label: "Administrador zona", value: "2", id:2, associatedField: "codPerfil" },
								{ label: "Responsable de obra", value: "3", id:3, associatedField: "codPerfil" },
								{ label: "Intermediario", value: "4", id:4, associatedField: "codPerfil" }
							],
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						},
						{
							name: "codAcceso",
							type: "select",
							label: "Acceso",
							placeholder: "Selecciona el tipo de acceso",
							options: [
								{ label: "Gestión", value: "1", id:1, associatedField: "codAcceso"},
								{ label: "Consulta", value: "2", id:2, associatedField: "codAcceso" }
							],
							required: true,
							disabled: false,
							labelVisible: true,
							visible: true
						}
					]
				}
			]}
      filterFields={filterFields}
      loading={loading}
			keyProp="codUsuario"
      // addApiUrl="/api/Usuario/SetUsuario"
      // editApiUrl="/api/Usuario/EditUsuario"
      // deleteApiUrl="/api/Usuario/DeleteUsuario"
      />
    </PageLayout>
  );
}
